import { render, staticRenderFns } from "./trainingitems.vue?vue&type=template&id=1fddb6e7&scoped=true&lang=pug"
import script from "./trainingitems.vue?vue&type=script&lang=js"
export * from "./trainingitems.vue?vue&type=script&lang=js"
import style0 from "./trainingitems.vue?vue&type=style&index=0&id=1fddb6e7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fddb6e7",
  null
  
)

export default component.exports